<template>
<div class="flex-col gap-y-md">
  <dd-header-card header="Premies">
    <div v-if="coverageCodesOptions" class="flex-col gap-y-sm">
      <div v-for="(premium, idx) in premiums"
           :key="idx" class="flex-row justify-content-space-between gap-lg"
      >
        <dd-select
            class="coverage-code"
            :data-dusk="premium + '-coverage-code'"
            v-model="self()[premium + '_coverage_code']"
            :options="coverageCodesOptions"
            searchable
        >
        </dd-select>
        <dd-amount-input
            :data-dusk="premium + '-premium'"
            v-model="self()[premium + '_premium']">

        </dd-amount-input>
      </div>
    </div>
  </dd-header-card>
  <BonusMalus v-if="hasBonusMalus"/>
</div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import { mapFields }from 'vuex-map-fields';
import BonusMalus from './BonusMalus.vue';
export default {
  name: "Premiums",
  components: {
    BonusMalus
  },
  computed: {
    ...mapGetters(`$_generic_insurance`, {
      hasBonusMalus: 'hasBonusMalus',
      coverageCodesOptions: 'coverageCodesOptions',
    }),
    ...mapFields(`$_generic_insurance`, [
      'form.primary_premium',
      'form.primary_coverage_code',
      'form.secondary_premium',
      'form.secondary_coverage_code',
      'form.tertiary_premium',
      'form.tertiary_coverage_code',
      'form.quaternary_premium',
      'form.quaternary_coverage_code',
      'form.quinary_premium',
      'form.quinary_coverage_code',
    ]),

  },
  methods: {
    self() {
      return this
    },
  },
  data() {
    return {
      premiums: [
        'primary',
        'secondary',
        'tertiary',
        'quaternary',
        'quinary',
      ]
    }
  }
}
</script>

<style lang="scss" scoped>
@import "~@/_default.scss";
.coverage-code {
  width: 100%;
}
.amount {
  width: 160px;
}
</style>
